import { RQ_FILTERED_SHOP_PRODUCTS } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { buildShopSearchQueryParams } from '@/modules/search/helpers';
import { useSearchFilters } from '@/modules/search/useSearchFilters';
import { useSearchInput } from '@/modules/search/useSearchInput';

export function useFilteredProductsQueryKey(sellerId?: number) {
  const { searchInput } = useSearchInput();
  const { searchFilters } = useSearchFilters();
  const { location } = useCurrentLocation();
  const searchQueryParams = buildShopSearchQueryParams({
    location,
    searchInput,
    searchFilters,
  });

  return [
    RQ_FILTERED_SHOP_PRODUCTS,
    { sellerId, searchInput, searchQueryParams },
  ];
}
